<template>
  <div id="router" :style="viewStyle">
    <div id="box" class="pa-5" style="margin-top:3%">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1" >合作備忘錄資訊</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row v-if="setCopy=='1'" class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>合作備忘錄案號</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0">
              <v-text-field class="text_field" dense outlined placeholder="輸入合作備忘錄案號" v-model="datasets.comemoNo"
              :readonly="(datasets.comemoCompany != '')" :background-color="(datasets.comemoCompany != '')?'#F4F8F9':'#FFF'"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="setCopy!='1'" class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>合作備忘錄案號</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="erpComeMo">
                <v-row class="my-1">
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">已審核案號</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="2" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">其他案號</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="setCopy!='1'" class="ma-0 pa-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"></div>
            </v-col>
            <v-col v-if="erpComeMo == '1'" class="col-10 col-md-8">
              <v-autocomplete class="text_field autocomplete" placeholder="選擇合作備忘錄案號"
              :items="erpComeMoListAll" item-text="comemoNo" item-value="comemoNo" v-model="datasets.comemoNo" @change="chooseComemoNo()"></v-autocomplete>
            </v-col>
            <v-col v-if="erpComeMo != '1'" class="col-7 col-md-6">
              <v-text-field class="text_field" dense outlined placeholder="請輸入合作備忘錄案號" v-model="datasets.comemoNo"
              :readonly="(datasets.comemoCompany != '')" :background-color="(datasets.comemoCompany != '')?'#F4F8F9':'#FFF'"
              @keyup="datasets.comemoNo = datasets.comemoNo.replace(/[\u4e00-\u9fa5]/ig,'') && datasets.comemoNo.toUpperCase(), datasets.comemoNo = $Global.toCDB(datasets.comemoNo)"></v-text-field>
            </v-col>
            <v-col v-if="erpComeMo != '1'" class="col-3 col-md-2 pl-0">
              <v-btn outlined style="width:100%; height:40px; background:#81c0e2; border-radius:8px; border:none" @click="checkComemoNo()">
                <span style="color:#FFFFFF">審核</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>申請學校/單位</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.comemoCompany"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.comemoDept"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">申請考試場次資訊</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-3 pt14"><span class="start">*</span>考試方式</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="datasets.exportStatus">
                <v-row class="my-1">
                  <v-radio v-for="(data,index) in examMethodList" :key="index" :value = "(index+1).toString()" class="pr-10 pb-1" color="#215DA7">
                    <!-- :color = colorIdList[index].color -->
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">{{data.title}}</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證分類</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇" :items="manufacturerList" v-model="datasets.classItemManufacturer"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證項目</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇" :items="classItemClass1List" v-model="datasets.class1"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證模組</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇" :items="classItemClass2List" v-model="datasets.class2"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證廠商</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇" :items="classItemClass3List" item-text="class3" item-value="class3" v-model="datasets.class3"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證費用</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="系統將會自動帶入" v-model="datasets.examFee"></v-text-field>
            </v-col>
            <!-- <v-col cols="8">
                <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇" :items="feeTypeList" item-text="title" item-value="valuev" v-model="datasets.feeType"></v-select>
            </v-col> -->
          </v-row>
          <!-- <v-row class="ma-0">
            <v-col cols="2"></v-col>
            <v-col cols="8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examFee"></v-text-field>
            </v-col>
          </v-row> -->
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>認證日期</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-menu ref="menu" v-model="menu" transition="scale-transition" :close-on-content-click="false" offset-y left min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="請選擇"
                    v-model="datasets.examDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker v-model="datasets.examDate" no-title scrollable :allowed-dates="allowedDates"
                 @change="$refs.menu.save(datasets.examDate)"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證時間</div>
            </v-col>
            <v-col class="col-5 col-md-4">
              <v-autocomplete class="text_field autocomplete" placeholder="選擇認證開始時間" :items="examTimeList" item-text="time" item-value="time" v-model="datasets.examStartTime"></v-autocomplete>
            </v-col>
            <v-col class="col-5 col-md-4">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="系統將會自動帶入時間" v-model="datasets.examTime"></v-text-field>
              <!-- <v-select class="text_field" dense background-color="white" outlined placeholder="選擇時間" :items="TITLE_LIST" item-text="title" item-value="title"></v-select> -->
            </v-col>
          </v-row>
          <v-row class="ma-0 pb-1">
            <v-col class="px-0 col-2 col-md-4"></v-col>
            <v-col class="col-10 col-md-8" style="text-align:left">
              <h6 class="start">*認證考試考場佈場時間為一個小時，麻煩老師提前一個小時借用教室</h6>
            </v-col>
          </v-row>
          <v-row class="ma-0 py-1">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
            </v-col>
            <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
              <v-radio-group class="ma-0 pa-0" dense v-model="datasets.payGroup">
                <v-row>
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">團體繳費</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="2" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">個人繳費</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14">團體收據抬頭</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入收據抬頭/如不需要可寫「無」" maxlength="50" v-model="datasets.groupReceiptTitle"></v-text-field>
            </v-col>
          </v-row>          
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>學校類別</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇學校類別" :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="datasets.collegeCategory"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證考場</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇行政區" :items="collegeAreaListByCategoryList" v-model="datasets.companyCountry"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2"></v-col>
            <v-col class="col-10 col-md-8">
              <v-autocomplete class="text_field autocomplete" placeholder="請選擇考場" :items="collegeListByCategoryAndCountryList" item-text="name" item-value="name" v-model="datasets.company" ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2"></v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇校區" :items="campusList" item-text="title" item-value="title" v-model="datasets.campusName"></v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="請輸入" maxlength="50" v-model="datasets.dept"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證考區</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-select class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="系統將會自動帶入"
              :items="frontendAreaList" item-text="title" item-value="valuev" v-model="datasets.frontendArea">
                <template v-slot:append>
                  <v-icon></v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>認證地址</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" placeholder="詳細地址" outlined v-model="datasets.campusAddress"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0" v-if="datasets.exportStatus!=4">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>大樓及認證教室</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="50" v-model="datasets.examClassroom"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0" v-if="datasets.exportStatus!=4">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>可容納座位數</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="4" v-model="datasets.abSet"
              @keyup="[datasets.abSet= datasets.abSet.replace(/\D/g,'')]"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2"></v-col>
            <v-col cols="8" style="text-align:left">
              <h6 v-if="datasets.exportStatus==1 || datasets.exportStatus==3" class="start">*可容納座位數為:可使用電腦台數扣掉備用電腦五台</h6>
              <h6 v-if="datasets.exportStatus==2" class="start pb-1">*可容納座位數為:教室座位數量</h6>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-1 ml-0 pt14" style="line-height:1.2"><span class="start">*</span>報名繳費截止日期</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="border pt14" dense readonly background-color="#F4F8F9" placeholder="系統將會自動帶入" outlined v-model="datasets.deadlineDate"></v-text-field>
              <!-- <v-menu ref="menu1" v-model="menu1" transition="scale-transition" :close-on-content-click="false" offset-y left min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="報名截止日"
                    v-model="datasets.deadlineDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker v-model="datasets.deadlineDate" no-title scrollable :allowed-dates="allowedDates"
                 @change="$refs.menu1.save(datasets.deadlineDate)"></v-date-picker>
              </v-menu> -->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">詳細資訊</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row>
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>是否開放併考</div>
            </v-col>
            <v-col class="col-6 py-0 pt-2 pl-7">
              <v-radio-group class="ma-0 pa-0" dense v-model="datasets.allowTestTogether">
                <v-row>
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">是</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="0" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">否</span>
                    </template>
                  </v-radio>
                  <div class="ma-0 pa-0" @mouseenter="mouseInfor=1" @mouseout="mouseInfor=0">
                    <v-icon style="background:#FFF">mdi-alert-circle-outline</v-icon>
                  </div>
                  <div v-if="mouseInfor==1" class="mt-n2 px-2 border absolute" style="width:220px; height:120px">
                    <h4 class="px-2 pt-3" style="font-size:12pt">是否開放非授課學生併考?</h4>
                    <h4 class="px-2 pb-3" style="font-size:12pt">如不開放，請點選「否」以及建議點選「需使用密碼報名」</h4>
                  </div>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row>
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>是否需密碼報名</div>
            </v-col>
            <v-col class="col-5 col-sm-4 py-0 pt-2 pl-7">
              <v-radio-group class="ma-0 pa-0" dense v-model="datasets.usePasswd">
                <v-row>
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">是</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="0" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">否</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
            </v-col>
            <v-col class="col-5 col-sm-6 col-md-4 py-0 pr-7">
              <v-row v-if="datasets.usePasswd == '1'">
                <div class="text-right mt-2 px-2 pt14">密碼</div>
                  <v-text-field class="border pt14" dense :readonly="(datasets.usePasswd =='0')" :background-color="(datasets.usePasswd == '0')?'#F4F8F9':'#FFF'" placeholder="請輸入六位數字" outlined style="width:15px" 
                  maxlength="6" v-model="datasets.passwd" @keyup="[datasets.passwd= datasets.passwd.replace(/\D/g,'')]"></v-text-field>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-row class="ma-0">
          <v-col class="col-2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>是否有外籍考生</div>
          </v-col>
          <v-col class="py-0 pt-2 pl-6">
            <v-row class="ma-0">
              <v-radio-group class="ma-0 pa-0" dense v-model="datasets.examBranch">
                <v-row>
                  <v-radio class="pr-2" value="1" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">是</span>
                    </template>
                  </v-radio>
                  <v-radio class="pr-2" value="0" color="#215DA7">
                    <template v-slot:label>
                      <span class="pt14" style="color:#000000">否</span>
                    </template>
                  </v-radio>
                </v-row>
              </v-radio-group>
              <v-row v-if="datasets.examBranch=='1'" class="my-0 ml-4 pa-0">
                <v-checkbox v-for="(data, index) in examLimitList" :key = "index" :value = "data.valuev" class="pr-3 pa-0 ma-0" color="#215DA7" v-model="datasets.examLimit">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">{{data.title}}</span>
                  </template>
                </v-checkbox>
              </v-row>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
      <v-row class="ma-0 pt-1">
        <v-col class="col-2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>注意事項</div>
        </v-col>
        <v-col class="col-10 col-md-9">
          <!-- <v-text-field class="border pt14" dense background-color="white" outlined height=400px ></v-text-field> -->
          <textarea class="border pt14 pa-4" rows="6" readonly outlined required dense style="width:100%; background:#F4F8F9; border: 1px solid #999999" v-model="precautions.examWatch"></textarea>
          <!-- 要轉換為 v-model="datasets.examNotice" -->
        </v-col>
      </v-row>
    </div>

    <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">申請人資訊</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>姓名</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入姓名" maxlength="50" v-model="datasets.applyName"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入職稱" maxlength="50" v-model="datasets.applyJobTitle"></v-text-field>
              </v-col>
            </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => datasets.applyEmail = val' :domains='mailCandidateList'>
                <input class="emailAutoComplete" type="text" placeholder="請輸入電子信箱" maxlength="50" v-model='datasets.applyEmail'
                @keyup="[$refs.EmailAutoComplete.check($event), datasets.applyEmail= datasets.applyEmail.replace(/[\u4e00-\u9fa5]/ig,''), datasets.applyEmail = $Global.toCDB(datasets.applyEmail)]" />
              </email-auto-complete>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電話</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="02-0000-0000" maxlength="30" v-model="datasets.applyTel"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>手機</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense background-color="white" outlined placeholder="0900000000" maxlength="10" v-model="datasets.applyCtel"
              @keyup="[datasets.applyCtel= datasets.applyCtel.replace(/\D/g,'')]"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">聯絡人資訊</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row>
            <v-col class="px-0 col-2 col-md-4"></v-col>
            <v-col class="col-10 col-md-8">
              <v-checkbox class="ma-0 pa-0 pt14" color="#81C0E2" label="同申請人" v-model="datasets.sameContact"></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>姓名</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="請輸入姓名" :readonly="(datasets.sameContact==true)" :background-color="(datasets.sameContact==true)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.contact"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="請輸入職稱" :readonly="(datasets.sameContact==true)" :background-color="(datasets.sameContact==true)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.jobtitle"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <email-auto-complete ref="EmailAutoComplete2" :onCompletion='(val) => datasets.email = val' :domains='mailCandidateList'>
                <input class="emailAutoComplete" type="text" :readonly="(datasets.sameContact==true)" placeholder="請輸入電子信箱" maxlength="50" v-model='datasets.email'
                :style = "[{'background-color' : (datasets.sameContact==true) ? '#F4F8F9' : '#FFF'}]"
                @keyup="[$refs.EmailAutoComplete2.check($event), datasets.email= datasets.email.replace(/[\u4e00-\u9fa5]/ig,''), datasets.email = $Global.toCDB(datasets.email)]" />
              </email-auto-complete>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電話</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="02-0000-0000" :readonly="(datasets.sameContact==true)" :background-color="(datasets.sameContact==true)?'#F4F8F9':'#FFF'" maxlength="30" v-model="datasets.tel"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>手機</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="0900000000" :readonly="(datasets.sameContact==true)" :background-color="(datasets.sameContact==true)?'#F4F8F9':'#FFF'" maxlength="10" v-model="datasets.ctel"
              @keyup="[datasets.ctel= datasets.ctel.replace(/\D/g,'')]"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">授課教師資訊</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row>
            <v-col class="px-0 col-2 col-md-4"></v-col>
            <v-col class="col-10 col-md-8">
              <v-checkbox class="ma-0 pa-0 pt14" color="#81C0E2" label="同申請人" v-model="datasets.sameTeacher"></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>姓名</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="請輸入姓名" :readonly="(datasets.sameTeacher==true)" :background-color="(datasets.sameTeacher==true)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.teacher"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="請輸入職稱" :readonly="(datasets.sameTeacher==true)" :background-color="(datasets.sameTeacher==true)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.teacherJobTitle"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <email-auto-complete ref="EmailAutoComplete3" :onCompletion='(val) => datasets.teacherEmail = val' :domains='mailCandidateList'>
                <input class="emailAutoComplete" type="text" :readonly="(datasets.sameTeacher==true)" placeholder="請輸入電子信箱" maxlength="50" v-model='datasets.teacherEmail'
                :style = "[{'background-color' : (datasets.sameTeacher==true) ? '#F4F8F9' : '#FFF'}]"
                @keyup="[$refs.EmailAutoComplete3.check($event), datasets.teacherEmail= datasets.teacherEmail.replace(/[\u4e00-\u9fa5]/ig,''), datasets.teacherEmail = $Global.toCDB(datasets.teacherEmail)]" />
              </email-auto-complete>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電話</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="02-0000-0000" :readonly="(datasets.sameTeacher==true)" :background-color="(datasets.sameTeacher==true)?'#F4F8F9':'#FFF'" maxlength="30" v-model="datasets.teacherTel"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>手機</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense outlined placeholder="0900000000" :readonly="(datasets.sameTeacher==true)" :background-color="(datasets.sameTeacher==true)?'#F4F8F9':'#FFF'" maxlength="10" v-model="datasets.teacherCtel"
              @keyup="[datasets.teacherCtel= datasets.teacherCtel.replace(/\D/g,'')]"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">證書寄送資訊</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4"></v-col>
            <v-col class="col-10 col-md-8">
              <v-checkbox class="ma-0 pa-0 pt14" color="#81C0E2" label="同申請人" v-model="datasets.sameRcvCert"></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>收信人</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense :readonly="(datasets.sameRcvCert==true)" :background-color="(datasets.sameRcvCert==true)?'#F4F8F9':'#FFF'" outlined placeholder="請輸入姓名" maxlength="50" v-model="datasets.rcvCertName"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>聯絡手機</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense :readonly="(datasets.sameRcvCert==true)" :background-color="(datasets.sameRcvCert==true)?'#F4F8F9':'#FFF'" outlined placeholder="請輸入手機" maxlength="10" v-model="datasets.rcvCertCtel"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>寄送地址</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-row v-if="datasets.sameRcvCert!=true" class="px-3">
                <v-select class="text_field mr-2" dense background-color="white" outlined placeholder="請選擇縣市" :items="countryList" item-text="country" item-value="country" style="width:48%" v-model="datasets.receiverCountry"></v-select>
                <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇行政區" :items="areaListByCountry" item-text="area" item-value="area" style="width:48%" v-model="datasets.receiverArea"></v-select>
              </v-row>
              <v-row class="px-3">
                <v-text-field class="text_field" dense :readonly="(datasets.sameRcvCert==true)" :background-color="(datasets.sameRcvCert==true)?'#F4F8F9':'#FFF'" outlined placeholder="請輸入詳細地址" maxlength="200" v-model="datasets.receiverAddress"></v-text-field>
              </v-row>
              <v-row class="px-3">
                <h6 class="start text-left">*若有付費申請團體紙本證書統一以宅配寄送，送出前煩請確認收件人、地址與聯絡電話是否正確無誤</h6>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-btn class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none" @click="newDataset()">
      <span style="color:#FFFFFF">新增</span>
    </v-btn>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
  </div>
</template>

<script>
import EmailAutoComplete from "vue-email-autocomplete";
import "vue-email-autocomplete/dist/vue-email-autocomplete.css";
import ShowMsg from '@/dialogs/ShowMsg'
import moment from 'moment'

export default {
  name: 'ProjectApplication',
  components: {EmailAutoComplete,ShowMsg},
  mounted(){
    Promise.all([
      new Promise((resolve)=>{resolve(this.$Global.getExamMethodList().then(res=>{ this.examMethodList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getFrontendAreaList().then(res=>{ this.frontendAreaList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getClassItemManufacturerList().then(res=>{ this.manufacturerList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getMailCandidateList().then(res=>{ this.mailCandidateList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getCountryList().then(res=>{ this.countryList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getExamLimitList().then(res=>{ this.examLimitList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getPrecautions().then(res=>{ this.precautions = res }))}),
      new Promise((resolve)=>{resolve(this.getExamTimeList())}),
      new Promise((resolve)=>{resolve(this.$Global.getMemberTeacher().then(res=>{ this.examWatchList = JSON.parse(res.examWatch)}))}),
    ]).then(()=>{
      if(this.$route.query.setCopy){
        Promise.all([
          new Promise((resolve)=>{resolve(this.getDataset())}),
          new Promise((resolve)=>{resolve(this.setCopy = '1')}),
        ]).then(()=>{
          setTimeout(() => { this.initDone = true; }, 1000); //delay 0.2s
        })
      } else {
        Promise.all([
          new Promise((resolve)=>{resolve(this.getDatasetForm())}),
          new Promise((resolve)=>{resolve(this.getErpComeMo())}),
          new Promise((resolve)=>{resolve(this.setCopy = '2')}),
        ]).then(()=>{
          setTimeout(() => { this.initDone = true; }, 1000); //delay 0.2s
        })
      }
    })
  },
  data:() => ({
    datasets: [],
    viewStyle: {},
    mouseInfor: 0,
    erpComeMo: '1',
    initDone: false,
    setCopy: '1', // 1-複製場次 2-新建場次

    memberInfo: [],
    erpComeMoListAll: [],
    erpComeMoList: [],
    examMethodList: [],
    frontendAreaList: [],
    collegeCategoryList: [],
    collegeAreaListByCategoryList: [],
    collegeListByCategoryAndCountryList: [],
    campusList: [],
    manufacturerList: [],
    classItemClass1List: [],
    classItemClass2List: [],
    classItemClass3List: [],
    feeTypeList: [],
    mailCandidateList: [],
    countryList: [],
    areaListByCountry: [],
    examTimeList: [],
    examLimitList: [],
    examWatchList: [],
    teacherIdCardList: [],

    menu: false,
    // day: '',
    menu1: false,
    // day1: '',
    // menu2: false,
    // day2: '',
    precautions: [],

    TITLE_LIST: [],

    requiredField:['comemoNo','comemoCompany','comemoDept','exportStatus','examDate','examTime','frontendArea','collegeCategory','companyCountry','company','campusName','dept','campusAddress',
    'class1','class2','class3','examFee','payGroup','deadlineDate','applyName','applyJobTitle','applyEmail','applyTel','applyCtel','contact','jobtitle'
    ,'email','tel','ctel','teacher','teacherJobTitle','teacherEmail','teacherTel','teacherCtel','allowTestTogether','usePasswd','rcvCertName','rcvCertCtel','receiverAddress'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "erpComeMo":function(){
      if(this.initDone){
        this.datasets.comemoNo = ''
        this.datasets.comemoCompany = ''
        this.datasets.comemoDept = ''
      }
    },
    "datasets.comemoCompany":function(){
      if(this.initDone){
        this.getMemberInfo()
      }
    },
    "datasets.collegeCategory":function(){
      if(this.initDone){
        this.datasets.companyCountry = ''
        this.collegeListByCategoryAndCountryList = []
      }
      this.$Global.getCollegeAreaListByCategoryList(this.datasets.collegeCategory).then(res=>{ this.collegeAreaListByCategoryList = res })
    },
    "datasets.companyCountry":function(){
      if(this.initDone){
        this.datasets.company = ''
        this.campusList = []
      }
      this.$Global.getCollegeListByCategoryAndCountryList(this.datasets.collegeCategory, this.datasets.companyCountry, true).then(res=>{ this.collegeListByCategoryAndCountryList = res })
    },
    "datasets.company":async function(){
      if(this.initDone){
        this.datasets.campusName = ''
        this.datasets.frontendArea = ''
        this.datasets.campusAddress = ''
      }
      if(this.collegeListByCategoryAndCountryList.length == 0){
        await this.$Global.getCollegeListByCategoryAndCountryList(this.datasets.collegeCategory, this.datasets.companyCountry, true).then(res=>{ this.collegeListByCategoryAndCountryList = res })
      }
      this.getCampusList(this.datasets.company,this.collegeListByCategoryAndCountryList)
      {
        let value = this.datasets.company
        var index = this.collegeListByCategoryAndCountryList.findIndex(function(item){return item.name == value})
        if(index != -1){
          this.datasets.frontendArea = this.collegeListByCategoryAndCountryList[index].frontendArea
        }
      }
    },
    "datasets.campusName":function(){
      if(this.initDone && this.datasets.campusName){
        this.datasets.campusAddress = ''
        {
          let value = this.datasets.campusName
          var index = this.campusList.findIndex(function(item){return item.title == value})
          this.datasets.campusAddress = this.campusList[index].address
        }
      }
    },
    "datasets.classItemManufacturer":function(){
      if(this.initDone){
        this.datasets.class1 = ''
        this.classItemClass2List = []
        this.$Global.getClassItemClass1ManufacturerList(this.datasets.classItemManufacturer).then(res=>{ this.classItemClass1List = res })
      }
    },
    "datasets.class1":function(){
      if(this.initDone){
        this.datasets.class2 = ''
        this.classItemClass3List = []
      }
      this.$Global.getClassItemClass2List(this.datasets.class1).then(res=>{ this.classItemClass2List = res })
    },
    "datasets.class2":function(){
      if(this.initDone){
        this.datasets.class3 = ''
        this.datasets.extensionTime = ''
        this.feeTypeList = []
      }
      this.$Global.getClassItemClass3List(this.datasets.class1, this.datasets.class2).then(res=>{ this.classItemClass3List = res })
    },
    "datasets.class3":function(){
      if(this.initDone){
        // this.$Global.getFeeTypeList().then(res=>{ this.feeTypeList = res })
        this.datasets.extensionTime = ''
        this.datasets.feeType = '2'
        this.datasets.examFee = this.$Global.getExamFee(this.classItemClass3List,this.datasets.class3,this.datasets.feeType)
        this.getExamTime()
      }
      //考試總時長
      let value = this.datasets.class3
      var index = this.classItemClass3List.findIndex(function(item){return item.class3 == value})
      if(index !== -1){
        this.datasets.extensionTime = this.classItemClass3List[index].examTime
      }
    },
    "datasets.sameContact":function(){
      if(this.initDone){
        if(this.datasets.sameContact == true){
          if(!this.datasets.applyName || !this.datasets.applyJobTitle || !this.datasets.applyEmail || !this.datasets.applyTel || !this.datasets.applyCtel){
            this.$refs.ShowMsg.open(0,'請確認申請人資訊','申請人資訊(姓名/職稱/電子信箱/電話/手機)尚未填寫完整')
            setTimeout(() => { this.datasets.sameContact = false }, 1); //delay 0.01s
            return
          }
          this.datasets.contact = this.datasets.applyName
          this.datasets.jobtitle = this.datasets.applyJobTitle
          this.datasets.email = this.datasets.applyEmail
          this.datasets.tel = this.datasets.applyTel
          this.datasets.ctel = this.datasets.applyCtel
        }
      }
    },
    "datasets.sameTeacher":function(){
      if(this.initDone){
        if(this.datasets.sameTeacher == true){
          if(!this.datasets.applyName || !this.datasets.applyJobTitle || !this.datasets.applyEmail || !this.datasets.applyTel || !this.datasets.applyCtel){
            this.$refs.ShowMsg.open(0,'請確認申請人資訊','申請人資訊(姓名/職稱/電子信箱/電話/手機)尚未填寫完整')
            setTimeout(() => { this.datasets.sameTeacher = false }, 1); //delay 0.01s
            return
          }
          this.datasets.teacher = this.datasets.applyName
          this.datasets.teacherJobTitle = this.datasets.applyJobTitle
          this.datasets.teacherEmail = this.datasets.applyEmail
          this.datasets.teacherTel = this.datasets.applyTel
          this.datasets.teacherCtel = this.datasets.applyCtel
        }
      }
    },
    "datasets.sameRcvCert":function(){
      if(this.initDone){
        if(this.datasets.sameRcvCert == true){
          if(!this.datasets.applyName || !this.datasets.applyCtel || !this.datasets.campusAddress){
            this.$refs.ShowMsg.open(0,'請確認資訊','申請人資訊(姓名/手機)及「場次資訊的認證地址」尚未填寫完整')
            setTimeout(() => { this.datasets.sameRcvCert = false }, 1); //delay 0.01s
            return
          }
          this.datasets.rcvCertName = this.datasets.applyName
          this.datasets.rcvCertCtel = this.datasets.applyCtel
          this.datasets.receiverCountry = ''
          this.datasets.receiverArea = ''
          this.datasets.receiverAddress = this.datasets.campusAddress
        }
      }
    },
    "datasets.receiverCountry":function(){
      this.$Global.getAreaListByCountryList(this.datasets.receiverCountry).then(res=>{ this.areaListByCountry = res })
    },
    "datasets.examDate":function(){
      if(this.initDone){
        if(this.datasets.examDate < moment().add(7, 'days').format('YYYY-MM-DD')){
          this.$refs.ShowMsg.open(0,'無法開立考場','您無法開立 7日內的場次，請與學會人員聯絡，謝謝。')
          this.datasets.examDate = ''
          return
        }
        this.datasets.deadlineDate = ''
        this.$Global.getPaymentDeadline(this.datasets.examDate).then(res=>{ this.datasets.deadlineDate = res })
      }
    },
    "datasets.deadlineDate":function(){
      if(this.initDone){
        if(this.datasets.deadlineDate == ''){
          return
        }
        if(this.datasets.examDate < this.datasets.deadlineDate){
          this.$refs.ShowMsg.open(0,'輸入錯誤','報名繳費截止日期不得大於認證日期。')
          this.datasets.deadlineDate = ''
          this.$Global.getPaymentDeadline(this.datasets.examDate).then(res=>{ this.datasets.deadlineDate = res })
          return
        }
        // console.log('[B]datasets.examDate: ' + this.datasets.examDate)
        // console.log('[B]datasets.examDate.subtract: ' + moment(this.datasets.examDate).subtract(4, 'days').format('YYYY-MM-DD'))
        // console.log('[B]datasets.deadlineDate: ' + this.datasets.deadlineDate)
        // console.log('------------------------')
        if((moment(this.datasets.examDate).subtract(4, 'days').format('YYYY-MM-DD') <= this.datasets.deadlineDate) && (this.datasets.deadlineDate <= this.datasets.examDate)){
          this.$refs.ShowMsg.open(0,'輸入錯誤','報名繳費截止日期不得於認證日期 4日內。')
          this.datasets.deadlineDate = ''
          this.$Global.getPaymentDeadline(this.datasets.examDate).then(res=>{ this.datasets.deadlineDate = res })
          return
        }
      }
    },
    "datasets.examStartTime":function(){
      if(this.initDone){
        this.getExamTime()
      }
    },
    "datasets.usePasswd":function(){
      if(this.initDone){
        this.datasets.passwd = ''
      }
    },
    "datasets.examBranch":function(){
      if(this.initDone && this.datasets.examBranch == '0'){
        this.datasets.examLimit = []
      }
    },
  },
  computed: {},
  methods:{
    chooseComemoNo(){
      let value = this.datasets.comemoNo
      var index = this.erpComeMoListAll.findIndex(function(item){return item.comemoNo == value})
      if(index != -1){
        this.datasets.comemoCompany = this.erpComeMoListAll[index].company
        this.datasets.comemoDept = this.erpComeMoListAll[index].dept
      }
    },
    checkComemoNo(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpComeMoDrillDownByComemoNo',
        params: {
          'comemoNo':self.datasets.comemoNo,
        },
      }
      this.$http(request).then(function(response) {
        self.datasets.comemoCompany = response.data.data[0].company
        self.datasets.comemoDept = response.data.data[0].dept
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Pan-7956')
      }).finally(()=>{
        if(!self.datasets.comemoCompany){
          this.$refs.ShowMsg.open(0,'輸入錯誤','請輸入正確合作備忘錄案號。')
        }
      })
    },
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    allowedDates(val){
      // console.log('[allowedExamDates] date: ' + val)
      let dateMin = moment().add(0, 'days').format('YYYY-MM-DD')
      return (new Date(val) >= new Date(dateMin))
    },
    getExamTimeList(){
      this.examTimeList = [
        {time:'08:00'},{time:'08:10'},{time:'08:20'},{time:'08:30'},{time:'08:40'},{time:'08:50'},
        {time:'09:00'},{time:'09:10'},{time:'09:20'},{time:'09:30'},{time:'09:40'},{time:'09:50'},
        {time:'10:00'},{time:'10:10'},{time:'10:20'},{time:'10:30'},{time:'10:40'},{time:'10:50'},
        {time:'11:00'},{time:'11:10'},{time:'11:20'},{time:'11:30'},{time:'11:40'},{time:'11:50'},
        {time:'12:00'},{time:'12:10'},{time:'12:20'},{time:'12:30'},{time:'12:40'},{time:'12:50'},
        {time:'13:00'},{time:'13:10'},{time:'13:20'},{time:'13:30'},{time:'13:40'},{time:'13:50'},
        {time:'14:00'},{time:'14:10'},{time:'14:20'},{time:'14:30'},{time:'14:40'},{time:'14:50'},
        {time:'15:00'},{time:'15:10'},{time:'15:20'},{time:'15:30'},{time:'15:40'},{time:'15:50'},
        {time:'16:00'},{time:'16:10'},{time:'16:20'},{time:'16:30'},{time:'16:40'},{time:'16:50'},
        {time:'17:00'},{time:'17:10'},{time:'17:20'},{time:'17:30'},{time:'17:40'},{time:'17:50'},
        {time:'18:00'},{time:'18:10'},{time:'18:20'},{time:'18:30'},{time:'18:40'},{time:'18:50'},
        {time:'19:00'},{time:'19:10'},{time:'19:20'},{time:'19:30'},{time:'19:40'},{time:'19:50'},
        {time:'20:00'},{time:'20:10'},{time:'20:20'},{time:'20:30'}
      ]
    },
    getExamTime(){
      // console.log('[getExamTime] datasets.examStartTime: ' + this.datasets.examStartTime)
      // console.log('[getExamTime] class3: ' + this.datasets.class3)
      if(!this.datasets.examStartTime || !this.datasets.class3){
        this.datasets.examTime = ''
        return
      }

      var self = this
      var index = this.classItemClass3List.findIndex(function(item){return item.class3 == self.datasets.class3})
      var examTime
      if(index != -1){
        examTime = this.classItemClass3List[index].examTime
        // console.log('[getExamTime] examTime: ' + examTime)
      }

      let time = this.datasets.examStartTime.split(':')
      time[0] = parseInt(time[0]) + Math.floor((parseInt(time[1]) + parseInt(examTime)) / 60)
      time[0] = (Array(2).join('0') + time[0]).slice(-2)
      time[1] = (parseInt(time[1]) + parseInt(examTime)) % 60
      time[1] = (Array(2).join('0') + time[1]).slice(-2)
      // console.log('[getExamTime] time: ' + time[0] + ':' + time[1])

      let endTime = time.join(':')
      // console.log('[getExamTime] endTime: ' + endTime)

      this.datasets.examTime = this.datasets.examStartTime + '-' + endTime
    },
    getCampusList(company,list){
      let campusList = []
      let value = company
      var index = (list) ? list.findIndex(function(item){return item.name == value}) : -1
      if(index != -1){
        campusList.push({title: '總區', address: (list[index].country + list[index].area + list[index].address)})
        campusList.push({title: '遠距', address: '遠距'})
        if(list[index].campusName1){
          let list1 = JSON.parse(list[index].campusName1)
          for(var i=0; i<list1.length; i++){
            campusList.push({title: list1[i].campusName, address: list1[i].campusAddress})
          }
        }
      }
      this.campusList = campusList
    },
    getErpComeMo(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpComeMoDrillDownByApplicantIdCard',
        params: {
          'applicantIdCard':sessionStorage.getItem('cerpsMemberIdCard'),
        },
      }
      this.$http(request).then(function(response) {
        self.erpComeMoList = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Pan-7957')
      })
    },
    getMemberInfo(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpTeacher/' + sessionStorage.getItem('cerpsMemberId'),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.memberInfo = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Pan-7958')
      }).finally(()=>{
        this.datasets.applyName = self.memberInfo.name
        this.datasets.applyJobTitle = self.memberInfo.jobtitle
        this.datasets.applyEmail = self.memberInfo.email
        this.datasets.applyTel = self.memberInfo.tel
        this.datasets.applyCtel = self.memberInfo.ctel

        // self.erpComeMoListAll = []
        self.erpComeMoListAll = JSON.parse(JSON.stringify(self.erpComeMoList))
        let comemoNoList = JSON.parse(self.memberInfo.comemoNoList)

        for (var i=0; i<comemoNoList.length; i++) {
          if(comemoNoList[i].comemoNo != ''){
            self.erpComeMoListAll.push(comemoNoList[i])
          }
        }
      })
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExam/' + JSON.parse(this.$Global.decrypt(self.$route.query.setCopy)),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Pan-7959')
      }).finally(()=>{
        this.$Global.getClassItemClass1ManufacturerList(this.datasets.classItemManufacturer).then(res=>{ this.classItemClass1List = res })
        this.datasets.id=''
        this.datasets.teacherIdCard=''
        this.datasets.teacherName=''
        this.datasets.examName=''
        this.datasets.examNo=''
        this.datasets.applyDate=''
        this.datasets.createTime=''
        this.datasets.updateTime=''
        this.datasets.numOfApplicants=''
        this.datasets.exportStatus=''
        this.datasets.examDate=''
        this.datasets.examStartTime=''
        this.datasets.examTime=''
        this.datasets.examClassroom=''
        this.datasets.abSet=''
        this.datasets.payGroup=''
        this.datasets.deadlineDate=''
        this.datasets.deadlineTime=''
        this.datasets.examOpenDate=''
        this.datasets.applyStatus=''
        this.datasets.isExtend=''
        this.datasets.isResume=''
        this.datasets.receiptPrintCount=''
        this.datasets.certificatePrintCount=''
        this.datasets.directExportGrade=''
        this.datasets.examNotice=''
        this.datasets.examStaffId=''
        this.datasets.examStaffName=''
        this.datasets.examStaffLoginId=''
        this.datasets.deliveryNo=''
        this.datasets.totalAmount=''
        this.datasets.certificateNum=''
        this.datasets.gradeStatus=''
        this.datasets.payType=''
        this.datasets.updateId=''
        this.datasets.paymentNo = ''
        this.datasets.orderId = ''
        this.datasets.examCode = ''
        this.datasets.loginCode = ''
        this.datasets.examBranch = ''
        if(this.datasets.examLimit){
          this.datasets.examLimit = JSON.parse(this.datasets.examLimit)
        }else{
          this.datasets.examLimit = []
        }
      })
    },
    getDatasetForm(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpExam/' + '1', //TBD
        params: {},
      }
      this.$http(request).then(function(response) {
        if(response.data.data == null){
          self.$refs.ShowMsg.open(0,'唯一值錯誤','請聯繫系統管理人員，編號為Pan-7960')
        }else{
          self.datasets = response.data.data
        }
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Pan-7960')
      }).finally(()=>{
        for (var key in self.datasets) {
          self.datasets[key] = null;
        }
        self.datasets.sameContact = false //不可以是null
        self.datasets.sameRcvCert = false //不可以是null
        self.datasets.sameTeacher = false //不可以是null
        self.datasets.examBranch = ''
        self.datasets.examLimit = []
        self.getMemberInfo()
      })
    },
    newDataset() {
      if(!this.$Global.checkForm(this.datasets,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(!this.precautions.examWatch){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.datasets.exportStatus != 4 && (!this.datasets.examClassroom || !this.datasets.abSet)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.datasets.usePasswd == 1 && this.datasets.passwd != '' && this.datasets.passwd.length != 6 ){
        this.$refs.ShowMsg.open(0,'請輸入密碼','請輸入六碼的前台報名密碼')
        return
      }

      //teacherIdCard 更新機制新增或翻場次
      var teacherIdCardFinally = ''
      if(this.datasets.teacherIdCard){
        this.teacherIdCardList = this.datasets.teacherIdCard.split(',')
      }
      let index = this.teacherIdCardList.findIndex(function(item){return item == sessionStorage.getItem('cerpsMemberIdCard')})
      if(index == -1){
        this.teacherIdCardList.push(sessionStorage.getItem('cerpsMemberIdCard'))
      }
      for(var i=0; i<this.examWatchList.length; i++){
        if(this.examWatchList[i].company == this.datasets.company){
          let res = this.examWatchList[i].manage.split(',')
          for(var j=0; j<res.length; j++){
            let index = this.teacherIdCardList.findIndex(function(item){return item == res[j]})
            if(index == -1){
              this.teacherIdCardList.push(res[j])
            }
          }
        }
      }
      teacherIdCardFinally = this.teacherIdCardList.join(',')

      var allData = this.$Global.copy(this.datasets)
      allData = this.$Global.jsonConcat(allData,{'examNotice':this.precautions.examWatch})
      allData = this.$Global.jsonConcat(allData,{'createId':sessionStorage.getItem('cerpsMemberIdCard')})
      allData = this.$Global.jsonConcat(allData,{'memberType':sessionStorage.getItem('cerpsMemberType')})
      allData = this.$Global.jsonConcat(allData,{'teacherIdCard':teacherIdCardFinally})
      allData = this.$Global.jsonConcat(allData,{'teacherName':sessionStorage.getItem('cerpsMemberName')})
      allData = this.$Global.jsonConcat(allData,{'examCategory':'認證考試'})
      allData = this.$Global.jsonConcat(allData,{'applyStatus':'1'})
      allData = this.$Global.jsonConcat(allData,{'isExtend':'0'})
      allData = this.$Global.jsonConcat(allData,{'isResume':'0'})
      allData = this.$Global.jsonConcat(allData,{'directExportGrade':'0'})
      allData = this.$Global.jsonConcat(allData,{'deadlineTime':'22:00'})
      allData = this.$Global.jsonConcat(allData,{'receiverAddress':(allData.receiverCountry ? allData.receiverCountry : '') + (allData.receiverArea ? allData.receiverArea : '') + allData.receiverAddress})
      allData = this.$Global.jsonConcat(allData,{'receiverCountry':''})
      allData = this.$Global.jsonConcat(allData,{'receiverArea':''})
      allData = this.$Global.jsonConcat(allData,{'examLimit':JSON.stringify(this.datasets.examLimit)})
      var self = this
      var request = {
        method: 'POST',
        url: '/erpExam',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        self.$refs.ShowMsg.open(18,'','',true)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Pan-7961')
      })
    },
    onShowMsg(){
      this.redirectPath('/projectList')
      this.$root.$emit('menuName', '使用者專區');
      this.$root.$emit('subMenuName', '已申請專案認證查詢')
    },
  }
}
</script>